import React from 'react';
import PropTypes from 'prop-types';

function BadgeRow({ children, className = '' }) {
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>{children}</div>
  );
}

BadgeRow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
};

export default BadgeRow;
